import React, { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Link } from "react-router-dom";
import firestore from "../firebase.config";

import { makeStyles } from "@material-ui/core/styles";
import {
    Avatar,
    Button,
    Container,
    CssBaseline,
    TextField,
    Paper,
    Box,
    Grid,
    Typography,
} from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import AccountCircleIcon from "@material-ui/icons/AccountCircle";

import { useAuth } from "../context/AuthContext";

import "../App.css";
function Copyright() {
    return (
        <Typography variant="body2" color="textSecondary" align="center">
            {"Research Purpose Only © "}
            <Link color="inherit" href="#">
                VLearnAI
            </Link>
            {new Date().getFullYear()}
        </Typography>
    );
}

const useStyles = makeStyles((theme) => ({
    root: {
        height: "100vh",
    },
    image: {
        backgroundImage: "url(https://source.unsplash.com/random)",
        backgroundRepeat: "no-repeat",
        backgroundColor:
            theme.palette.type === "light"
                ? theme.palette.grey[50]
                : theme.palette.grey[900],
        backgroundSize: "cover",
        backgroundPosition: "center",
    },
    paper: {
        margin: theme.spacing(8, 4),
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
    },
    avatar: {
        margin: theme.spacing(1),
        backgroundColor: '#FD4641',
    },
    form: {
        width: "100%", // Fix IE 11 issue.
        marginTop: theme.spacing(1),
    },
    submit: {
        margin: theme.spacing(3, 0, 2),
    },
}));

export default function UpdateProfile() {
    //const emailRef = useRef();
    const fnameRef = useRef();
    const lnameRef = useRef();
    const passwordRef = useRef();
    const [userinfo, setUserInfo] = useState();
    const passwordConfirmRef = useRef();
    //const { currentUser, updatePassword, updateEmail } = useAuth();
    const { currentUser, updatePassword } = useAuth();
    const classes = useStyles();
    const history = useHistory();
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    //const [errorMessage, setErrorMessage] = useState("");

    const getUserDetail = async (uID) => {
        const userRef = await firestore.collection("users").doc(uID).get();
        const data = userRef.data();
        setUserInfo(data);
    };

    useEffect(() => {
        console.log(currentUser.uid);
        getUserDetail(currentUser.uid);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    function handleSubmit(e) {
        e.preventDefault();

        if (passwordRef.current.value !== passwordConfirmRef.current.value) {
            return setError("Passwords do not match");
        }
        console.log("Update button clicked");

        const username = {
            fname: fnameRef.current.value,
            lname: lnameRef.current.value,
        };

        const res = firestore
            .collection("users")
            .doc(currentUser.uid)
            .update(username);

        console.log(res);

        const promises = [];
        setLoading(true);
        setError("");

        if (passwordRef.current.value) {
            promises.push(updatePassword(passwordRef.current.value));
        }

        Promise.all(promises)
            .then(() => {
                history.push("/account");
            })
            .catch(() => {
                setError("Failed to update account");
            })
            .finally(() => {
                setLoading(false);
            });
    }

    return (
        <Container component="main" maxWidth="sm">
            {userinfo && (
                <Grid container component="main" className={classes.root}>
                    <CssBaseline />
                    <Grid item xs={12} component={Paper} elevation={6} square>
                        <div className={classes.paper}>
                            <Avatar className={classes.avatar}>
                                <AccountCircleIcon />
                            </Avatar>
                            <Typography component="h1" variant="h5">
                                Update Profile
                            </Typography>

                            {error && (
                                <Alert variant="outlined" severity="error">
                                    <AlertTitle>Error</AlertTitle>
                                    {error}
                                </Alert>
                            )}

                            <form
                                onSubmit={handleSubmit}
                                className={classes.form}
                            >
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            autoComplete="fname"
                                            name="firstName"
                                            inputRef={fnameRef}
                                            required
                                            fullWidth
                                            id="firstName"
                                            label="First Name"
                                            variant="outlined"
                                            defaultValue={userinfo.fname}
                                            autoFocus
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            autoComplete="lname"
                                            name="lastName"
                                            inputRef={lnameRef}
                                            required
                                            fullWidth
                                            id="lastName"
                                            label="Last Name"
                                            variant="outlined"
                                            defaultValue={userinfo.lname}
                                            autoFocus
                                        />
                                    </Grid>
                                    <TextField
                                        disabled
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        id="email"
                                        label="Email Address"
                                        name="email"
                                        defaultValue={userinfo.email}
                                    />
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        fullWidth
                                        name="password"
                                        label="Password"
                                        type="password"
                                        inputRef={passwordRef}
                                        id="password"
                                        helperText="Ignore it if do not wish to change password."
                                    />
                                    <TextField
                                        variant="outlined"
                                        margin="normal"
                                        inputRef={passwordConfirmRef}
                                        fullWidth
                                        name="password-confirm"
                                        label="Confirm Password"
                                        type="password"
                                        id="password-confirm"
                                        helperText="Ignore it if do not wish to change password."
                                    />
                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        color="primary"
                                        className={classes.submit}
                                        disabled={loading}
                                    >
                                        Update
                                    </Button>
                                    <Button
                                        fullWidth
                                        component={Link}
                                        to="/account"
                                        variant="contained"
                                        style={{
                                            backgroundColor: "#ba000d",
                                            color: "#fff",
                                        }}
                                    >
                                        Cancel
                                    </Button>
                                </Grid>

                                <Box mt={5}>
                                    <Copyright />
                                </Box>
                            </form>
                        </div>
                    </Grid>
                </Grid>
            )}
        </Container>
    );
}
